import { render } from "./Destination.vue?vue&type=template&id=6d796088&scoped=true"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"

import "./Destination.vue?vue&type=style&index=0&id=6d796088&lang=stylus"
import "./Destination.vue?vue&type=style&index=1&id=6d796088&lang=stylus&scoped=true"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d796088"]])

export default __exports__